define('apps/admin/views/modals/blank-modal',[
        'njs!apps/admin/templates/includes/modals/_blank_modal(params:tmpl=admin/main/includes/modals/_blank_modal.html)'
    ], function(template) {
        'use strict';

        return Mn.ItemView.extend({

            "events": {
                "click .comet-modal__button--cancel": "closeModal",
                "click .comet-modal-overlay--backdrop": "closeModal",
                "click .comet-modal__button--confirm": "closeModal"
            },

            "template": template,

            "initialize": function(opts){
            },

            "closeModal": function(event) {
                this.destroy();
            },


        });

});

